import React from "react";
import {WHYS} from "../../data/siteData";
import {asset, GRAD, SHADOW, stagger} from "../../utils";
import Icon from "../common/Icon";
import Bars from "../common/Bars";

const WhyChoose = () => (
    <section className="pb-container pb-intro">
        <p className="pb-pill" style={{background: 'rgba(150,41,142,0.13)', color: '#96298E', marginBottom: 16}}>
            <Icon name="star" size={14}/>Why choose
        </p>
        <img src={asset('assets/logo-black.png')} alt="Paddlers Box" className="pb-why-logo"/>
        <div className="pb-rule" style={{marginTop: 20}}><Bars w={16} h={4} gap={4}/></div>
        <div className="pb-whys">
            {WHYS.map((w, i) => (
                <div key={w.title} className="pb-reveal pb-why hover-lift-7" style={{
                    background: GRAD[w.color], boxShadow: '0 24px 46px -28px ' + SHADOW[w.color],
                    animationDelay: stagger(i)
                }}>
                    <span className="pb-why-icon"><Icon name={w.icon} size={26}/></span>
                    <h3 className="pb-why-title">{w.title}</h3>
                    <p className="pb-why-body">{w.body}</p>
                </div>
            ))}
        </div>
    </section>
);

export default WhyChoose;
